import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The best way to install the PostHog Java SDK is with a build system like Gradle or Maven. This ensures you can easily upgrade to the latest versions.`}</p>
    <p>{`Look up the latest version in `}<a parentName="p" {...{
        "href": "https://central.sonatype.com/artifact/com.posthog/posthog-server"
      }}>{`com.posthog.posthog-server`}</a>{`.`}</p>
    <h4 {...{
      "id": "gradle"
    }}>{`Gradle`}</h4>
    <p>{`All you need to do is add the `}<inlineCode parentName="p">{`posthog-server`}</inlineCode>{` module to your `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gradle_kotlin",
        "metastring": "file=build.gradle",
        "file": "build.gradle"
      }}>{`dependencies {
  implementation 'com.posthog:posthog-server:1.+'
}
`}</code></pre>
    <h4 {...{
      "id": "maven"
    }}>{`Maven`}</h4>
    <p>{`All you need to do is add the `}<inlineCode parentName="p">{`posthog-server`}</inlineCode>{` module to your `}<inlineCode parentName="p">{`pom.xml`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "file=pom.xml",
        "file": "pom.xml"
      }}>{`<dependency>
  <groupId>com.posthog</groupId>
  <artifactId>posthog-server</artifactId>
  <version>LATEST</version>
</dependency>
`}</code></pre>
    <h4 {...{
      "id": "other"
    }}>{`Other`}</h4>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://central.sonatype.com/artifact/com.posthog/posthog-server"
      }}>{`com.posthog.posthog-server`}</a>{` in the Maven Central Repository. Clicking on the latest version shows you options for adding dependencies for other build systems.`}</p>
    <h3 {...{
      "id": "setup"
    }}>{`Setup`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.posthog.server.PostHog;
import com.posthog.server.PostHogConfig;
import com.posthog.server.PostHogInterface;

class Sample {
  private static final String POSTHOG_API_KEY = "<ph_project_api_key>";
  private static final String POSTHOG_HOST = "<ph_client_api_host>";

  public static void main(String args[]) {
    PostHogConfig config = PostHogConfig
            .builder(POSTHOG_API_KEY)
            .host(POSTHOG_HOST)
            .build();
    
    PostHogInterface postHog = PostHog.with(config);

    postHog.close();  // send the last events in queue
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      